
import { Options, prop, Vue } from "vue-class-component";
import { AccountController } from "@/app/ui/controllers/AccountController";

class Props {
  flag = prop<string>({
    type: String,
    default: "",
  });
}
@Options({
  components: {},
})
export default class RTS extends Vue.with(Props) {
  get isAccountForeign() {
    return AccountController.accountData?.accountIsForeign;
  }
}
